<script setup lang="ts">
import { ref } from 'vue';
import type AuthUser from '~/types/authUser';
import { useSwitchCompany } from '~/composables/useSwitchCompany';

const { t } = useI18n();
const { user } = useUserSession();
const { switchCompany } = useSwitchCompany();
const authUser = user.value as AuthUser | null;
interface Role {
  roleName: string | null;
  companyId: string | null | undefined;
  companyName: string | null | undefined;
  companyStatus?: number | null;
}
const roles = ref<Role[]>(authUser?.roles || []);
const choice = roles.value.findIndex(
  (r) =>
    r.companyId === authUser?.companyId && r.roleName === authUser?.roleName && r.companyName === authUser?.companyName
);
const selectedCompanyRole = ref<string | undefined>(String(choice));
const setRole = async (key: string | undefined) => {
  if (!authUser) return;
  const selectedRole = roles.value[Number(key)];
  if (!selectedRole?.companyId || !selectedRole.roleName) return;

  const isOnline = useNuxtApp().$isOnline as Ref<boolean> | undefined;

  if (isOnline && !isOnline.value) {
    useToast().add({
      color: 'warning',
      icon: 'i-lucide-wifi-off',
      title: 'Modo Offline',
      description: 'A troca de empresa requer conexão com a internet.',
      duration: 3000
    });
    return;
  }

  await switchCompany(selectedRole.companyId);
};
</script>

<template>
  <div>
    <USelect
      v-model="selectedCompanyRole"
      size="md"
      :items="
        roles.map((r, i) => ({
          value: String(i),
          label: `${r.companyName || 'No Company'} - ${t(`userTypes.${r.roleName}`) || 'No Role'}`,
          disabled: r.companyStatus === 2
        }))
      "
      placeholder="Select Company & Role"
      variant="ghost"
      @change="selectedCompanyRole && setRole(selectedCompanyRole)"
    />
  </div>
</template>
